import { render } from "./CategoryList.vue?vue&type=template&id=20de204c&scoped=true"
import script from "./CategoryList.vue?vue&type=script&lang=js"
export * from "./CategoryList.vue?vue&type=script&lang=js"

import "./CategoryList.vue?vue&type=style&index=0&id=20de204c&scoped=true&lang=css"

import exportComponent from "/opt/vr23-npm/htdocs/templates/vr23/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20de204c"]])

export default __exports__